import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Landing from "@/pages/Landing";
import LeadForm from "@/pages/LeadForm";
import Quiz from "@/pages/Quiz";
import Results from "@/pages/Results";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSubmission from "@/pages/AdminSubmission";
import AdminGuard from "@/components/AdminGuard";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/lead" element={<LeadForm />} />
                    <Route path="/quiz" element={<Quiz />} />
                    <Route path="/results/:id" element={<Results />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route
                        path="/admin"
                        element={
                            <AdminGuard>
                                <AdminDashboard />
                            </AdminGuard>
                        }
                    />
                    <Route
                        path="/admin/submissions/:id"
                        element={
                            <AdminGuard>
                                <AdminSubmission />
                            </AdminGuard>
                        }
                    />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
